import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "ai-progress-popup";

const keys = addTranslations(RESOURCE_NAME, {
    header_title: {
        en: "Generating {{count}} questions",
        fr: "Génération de {{count}} questions",
    },
    header_title_one: {
        en: "AI generating suggestion for one question",
        fr: "Génération d'une suggestion pour une question",
    },
    header_title_other: {
        en: "AI generating suggestions for {{count}} questions",
        fr: "Génération de suggestions pour {{count}} questions",
    },
    header_title_completed_one: {
        en: "AI suggestion completed for one question",
        fr: "AI a généré une suggestion pour une question",
    },
    header_title_completed_other: {
        en: "AI suggestions completed for {{count}} questions",
        fr: "AI a généré des suggestions pour {{count}} questions",
    },
    progress: {
        en: "Less than {{count}} minutes remaining...",
        fr: "Moins de {{count}} minutes restantes...",
    },
    progress_one: {
        en: "Less than 1 minute remaining...",
        fr: "Moins d'une minute restante...",
    },
    progress_other: {
        en: "Less than {{count}} minutes remaining...",
        fr: "Moins de {{count}} minutes restantes...",
    },
    tooltip: {
        en: "Cannot close while generating",
        fr: "Ne peut pas fermer pendant la génération",
    },
});

export function useAiProgressPopupTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
